export const C = {
  bgBase:      '#161A1D',
  bgCard:      '#1C2127',
  bgSurface:   '#242B33',
  bgElevated:  '#2D3640',
  accent:      '#A8E063',
  accentDim:   'rgba(168,224,99,0.12)',
  blue:        '#60A5FA',
  blueDim:     'rgba(96,165,250,0.12)',
  amber:       '#FBB724',
  amberDim:    'rgba(251,183,36,0.12)',
  purple:      '#A78BFA',
  purpleDim:   'rgba(167,139,250,0.12)',
  danger:      '#FF6B6B',
  dangerDim:   'rgba(255,107,107,0.12)',
  textPrimary: '#F1F5F9',
  textSec:     '#9CA3AF',
  textMuted:   '#4A5568',
  border:      '#2D3640',
};

export const card = {
  background:   C.bgSurface,
  borderRadius: '16px',
  padding:      '16px',
  marginBottom: '12px',
  boxShadow:    '0 2px 12px rgba(0,0,0,0.3)',
};

export const sectionTitle = {
  fontSize:     '14px',
  fontWeight:   '600',
  color:        C.textPrimary,
  marginBottom: '14px',
};

export const filterPill = (active) => ({
  display:      'flex',
  alignItems:   'center',
  gap:          '6px',
  padding:      '6px 14px',
  borderRadius: '20px',
  fontSize:     '11px',
  fontWeight:   '500',
  border:       `1px solid ${active ? C.accent : C.border}`,
  background:   active ? C.accentDim : C.bgElevated,
  color:        active ? C.accent : C.textSec,
  cursor:       'pointer',
  whiteSpace:   'nowrap',
  flexShrink:   0,
});

export const kpiCard = {
  background:   C.bgSurface,
  borderRadius: '16px',
  padding:      '16px',
  boxShadow:    '0 2px 12px rgba(0,0,0,0.3)',
  flex:         1,
};

export const kpiIcon = (color) => ({
  width:           '40px',
  height:          '40px',
  borderRadius:    '12px',
  background:      color,
  display:         'flex',
  alignItems:      'center',
  justifyContent:  'center',
  flexShrink:      0,
});

export const badge = (up) => ({
  fontSize:     '11px',
  fontWeight:   '600',
  padding:      '2px 8px',
  borderRadius: '20px',
  color:        up ? '#A8E063' : '#FF6B6B',
  background:   up ? 'rgba(168,224,99,0.12)' : 'rgba(255,107,107,0.12)',
});

export const toggleGroup = {
  display:      'flex',
  gap:          '4px',
  background:   '#1C2127',
  padding:      '4px',
  borderRadius: '10px',
};

export const toggleBtn = (active) => ({
  flex:         1,
  padding:      '5px 10px',
  borderRadius: '8px',
  fontSize:     '11px',
  fontWeight:   '500',
  border:       'none',
  cursor:       'pointer',
  background:   active ? '#A8E063' : 'transparent',
  color:        active ? '#1C2127' : '#6B7280',
  transition:   'all 0.2s',
});

export const th = {
  padding:    '10px 12px',
  background: '#2D3640',
  color:      '#9CA3AF',
  textAlign:  'left',
  fontSize:   '11px',
  fontWeight: '600',
  letterSpacing: '0.5px',
};

export const td = {
  padding:      '10px 12px',
  borderBottom: '1px solid #242B33',
  fontSize:     '12px',
  color:        '#E5E7EB',
};

export const tdR = { ...td, textAlign: 'right' };